var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4191 34.148C39.5541 35.1244 39.8203 35.8537 40.2164 36.337C40.9416 37.2169 42.1833 37.6566 43.9425 37.6566C44.9963 37.6566 45.8517 37.5408 46.5089 37.3088C47.7558 36.8639 48.3792 36.0375 48.3792 34.8295C48.3792 34.1236 48.0698 33.5775 47.4516 33.1908C46.8328 32.8139 45.8616 32.4806 44.5369 32.1905L42.2752 31.6833C40.0519 31.1803 38.5153 30.6342 37.6645 30.0445C36.2245 29.0588 35.5041 27.517 35.5041 25.4194C35.5041 23.5055 36.2002 21.9155 37.5919 20.6494C38.9841 19.3833 41.0283 18.75 43.725 18.75C45.9773 18.75 47.8983 19.3467 49.4883 20.5406C51.0787 21.7345 51.9122 23.467 51.9895 25.7386H47.6977C47.6203 24.4528 47.0597 23.5397 46.0158 22.9983C45.3202 22.6406 44.4548 22.4616 43.4208 22.4616C42.2705 22.4616 41.3522 22.6936 40.6659 23.1577C39.9797 23.6217 39.6366 24.2691 39.6366 25.1006C39.6366 25.8642 39.9745 26.4347 40.6514 26.8116C41.0864 27.0628 42.0141 27.3577 43.4353 27.6961L47.1178 28.5802C48.7322 28.9669 49.95 29.4839 50.7717 30.1317C52.0477 31.1372 52.6856 32.5917 52.6856 34.4958C52.6856 36.4486 51.9389 38.07 50.4455 39.3605C48.952 40.6509 46.8427 41.2959 44.1164 41.2959C41.333 41.2959 39.1434 40.6603 37.5487 39.3891C35.9536 38.1183 35.1562 36.3712 35.1562 34.148H39.4191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 12.1875V47.8125H44.0625V44.5312H16.875V15.4688H44.0625V12.1875H13.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkale);
export default __webpack_public_path__ + "static/media/skale.375e9af17d9bcf847d9cf21e8dabaa02.svg";
export { ForwardRef as ReactComponent };